/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdEmployeeData200,
  GetApiV1PersonIdEmployeeData401,
  GetApiV1PersonIdEmployeeData404,
  GetApiV1PersonIdEmployeeData500,
  GetApiV1PersonIdEmployeeDataPathParams,
  GetApiV1PersonIdEmployeeDataQueryResponse,
} from "../../types/personEmployeeController/GetApiV1PersonIdEmployeeData.ts";
import { personEmployeeDataViewModelSchema } from "../personEmployeeDataViewModelSchema.ts";

export const getApiV1PersonIdEmployeeDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdEmployeeDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdEmployeeData200Schema = z.lazy(
  () => personEmployeeDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdEmployeeData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdEmployeeData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdEmployeeData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdEmployeeData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdEmployeeData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdEmployeeData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdEmployeeData500>;

export const getApiV1PersonIdEmployeeDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdEmployeeData200Schema,
) as unknown as ToZod<GetApiV1PersonIdEmployeeDataQueryResponse>;
